import React from 'react';
import { SidebarNavigation } from './SidebarNavigation.tsx';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F2F2F2' }}>
      <div className="max-w-6xl mx-auto py-12">
        <div 
          className="bg-white shadow-lg rounded-none min-h-screen"
          style={{ boxShadow: '0 0 10px rgba(0,0,0,0.35)' }}
        >
          <div className="flex">
            {/* Sidebar Navigation */}
            <div className="flex-shrink-0">
              <SidebarNavigation className="pl-8 pt-4" />
            </div>
            
            {/* Main Content */}
            <div className="flex-1 pl-8 pr-8 pt-4 pb-8">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}